import { render, staticRenderFns } from "./DeviceTypeCreateModal.vue?vue&type=template&id=2966a55c&"
import script from "./DeviceTypeCreateModal.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports